import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

const { PurchaseMethodsReducer } = PurchaseMethods;

export default function configureStore() {
    const rootReducer = combineReducers({
        purchaseMethods: PurchaseMethodsReducer,
        tradeInVehicle: Vehicle.TradeInVehicleReducer,
    });

    const store = createStore(rootReducer, applyMiddleware(thunk));

    return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js